import type React from 'react';

interface FullScreenMessageAction {
  label: string;
  onClick: () => void;
}

interface FullScreenMessageProps {
  text: string;
  action?: FullScreenMessageAction;
  footer?: React.ReactNode;
}

export default function FullScreenMessage({
  text,
  action,
  footer,
}: FullScreenMessageProps): JSX.Element {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        gap: 16,
        fontFamily: "'Inter', system-ui, sans-serif",
        background: '#F1F5F9',
      }}
    >
      <div style={{ fontSize: 14, color: '#334155', fontWeight: 500 }}>{text}</div>
      {action && (
        <button
          type="button"
          onClick={action.onClick}
          style={{
            padding: '10px 24px',
            background: '#1B4F8C',
            color: '#fff',
            border: 'none',
            borderRadius: 8,
            fontSize: 13,
            fontWeight: 700,
            cursor: 'pointer',
          }}
        >
          {action.label}
        </button>
      )}
    </div>
  );
}
